<template>
  <div>
    <div class="event-table">
      <!--:columnResizing="true"  表头可以拉伸-->
      <!--<DataGrid
        v-loading="loading"
        :data="event_data"
        :border="false"
        :striped="true"
        :style="{height:bottom_height+'px'}"
        class="f-full"
        @rowContextMenu="event_right_click"
        @sortChange="sortChange"
      >
        <GridColumn
          :sorter="sorter"
          field="id"
          align="left"
          title="用户信息"
          width="100"
        >
          <template
            slot="body"
            slot-scope="scope"
          >
           &lt;!&ndash; <span :title="scope.row.id">{{ scope.row.id }}</span>&ndash;&gt;
          </template>
</GridColumn>
<GridColumn :sorter="sorter" field="name" align="left" title="用户名称" width="50">
  <template slot="body" slot-scope="scope">
            <span :title="scope.row.name">{{ scope.row.name }}</span>
          </template>
</GridColumn>
<GridColumn :sorter="sorter" field="creatTime" align="left" title="上线时间" width="100">
  <template slot="body" slot-scope="scope">
            <span :title="scope.row.creatTime">{{ scope.row.creatTime }}</span>
          </template>
</GridColumn>
<GridColumn :sorter="sorter" field="address" align="left" title="地址" width="150">
  <template slot="body" slot-scope="scope">
            <span :title="scope.row.address">{{ scope.row.address }}</span>
          </template>
</GridColumn>
&lt;!&ndash; <GridColumn :sortable="true" :sorter="sorter" field="timestamp" align="left" title="设备类型" width="150">
  <template slot="body" slot-scope="scope">
            <div class="item">
              <div :title="timeExchange(scope.row.timestamp)">{{ timeExchange(scope.row.timestamp) }}</div>
            </div>
          </template>
</GridColumn>&ndash;&gt;
&lt;!&ndash; <GridColumn :sortable="true" :sorter="sorter" field="objectName" title="对象" align="left" width="800">
  <template slot="body" slot-scope="scope">
            <span :title="scope.row.objectName">{{ scope.row.objectName }}</span>
          </template>
</GridColumn>
<GridColumn :sortable="true" :sorter="sorter" field="objectType" title="对象类型" align="left" width="80">
  <template slot="body" slot-scope="scope">
            <div
              v-if="scope.row.objectType==='folder'"
              title="文件夹"
              class="title"
            >
              文件夹
            </div>
            <div
              v-if="scope.row.objectType==='project'"
              title="项目"
              class="title"
            >
              项目
            </div>
            <div
              v-if="scope.row.objectType==='server'"
              title="服务器"
              class="title"
            >
              服务器
            </div>
            <div
              v-if="scope.row.objectType==='logicalGroup'"
              title="逻辑组"
              class="title"
            >
              逻辑组
            </div>
            <div
              v-if="scope.row.objectType==='deviceGroup'"
              title="设备组"
              class="title"
            >
              设备组
            </div>
            <div
              v-if="scope.row.objectType==='device'"
              title="设备"
              class="title"
            >
              设备
            </div>
            <div
              v-if="scope.row.objectType==='subDevice'"
              title="子设备"
              class="title"
            >
              子设备
            </div>
            <div
              v-if="scope.row.objectType==='onlineChart'"
              title="曲线图-实时"
              class="title"
            >
              曲线图-实时
            </div>
            <div
              v-if="scope.row.objectType==='stateChange'"
              title="状态变化"
              class="title"
            >
              状态变化
            </div>
            <div
              v-if="scope.row.objectType==='timeChart'"
              title="时间表-本地"
              class="title"
            >
              时间表-本地
            </div>
            <div
              v-if="scope.row.objectType==='user'"
              title="用户"
              class="title"
            >
              用户
            </div>
            <div
              v-if="scope.row.objectType==='group'"
              title="用户组"
              class="title"
            >
              用户组
            </div>
            <div
              v-if="scope.row.objectType==='userGroupAlarm'"
              title="用户组-报警"
              class="title"
            >
              用户组-报警
            </div>
            <div
              v-if="scope.row.objectType==='alarmControl'"
              title="报警控制"
              class="title"
            >
              报警控制
            </div>
            <div
              v-if="scope.row.objectType==='value_Analog'"
              title="值-模拟量"
              class="title"
            >
              值-模拟量
            </div>
            <div
              v-if="scope.row.objectType==='value_Multistate'"
              title="值-多态"
              class="title"
            >
              值-多态
            </div>
            <div
              v-if="scope.row.objectType==='value_Binary'"
              title="值-二进制"
              class="title"
            >
              值-二进制
            </div>
            <div
              v-if="scope.row.objectType==='value_String'"
              title="值-字符串"
              class="title"
            >
              值-字符串
            </div>
            <div
              v-if="scope.row.objectType==='BinaryInput'"
              title="数字了输入"
              class="title"
            >
              数字量输入
            </div>
            <div
              v-if="scope.row.objectType==='BinaryOutput'"
              title="数字了输出"
              class="title"
            >
              数字量输出
            </div>
            <div
              v-if="scope.row.objectType==='AnalogInput'"
              title="模拟量输入"
              class="title"
            >
              模拟量输入
            </div>
            <div
              v-if="scope.row.objectType==='AnalogOutput'"
              title="模拟量输出"
              class="title"
            >
              模拟量输出
            </div>
            <div
              v-if="scope.row.objectType==='timeEvent'"
              title="时间事件-对象"
              class="title"
            >
              时间事件-对象
            </div>
            <div
              v-if="scope.row.objectType==='timeEventList'"
              title="时间事件-列表"
              class="title"
            >
              时间事件-列表
            </div>
            <div
              v-if="scope.row.objectType==='objectTransfer'"
              title="对象传输"
              class="title"
            >
              对象传输
            </div>
          </template>
</GridColumn>
<GridColumn :sortable="true" :sorter="sorter" field="userName" title="操作用户" align="left" width="100">
  <template slot="body" slot-scope="scope">
            <span :title="scope.row.userName">{{ scope.row.userName }}</span>
          </template>
</GridColumn>
<GridColumn :sortable="true" :sorter="sorter" field="description" align="left" title="事件描述">
  <template slot="body" slot-scope="scope">
            <span :title="scope.row.description">{{ scope.row.description }}</span>
          </template>
</GridColumn>&ndash;&gt;
&lt;!&ndash; <GridColumn :sortable="true" :sorter="sorter" field="alarmStatus" align="left" title="状态" width="100">
  <template slot="body" slot-scope="scope">
            <span :title="scope.row.alarmStatus">{{ scope.row.alarmStatus }}</span>
          </template>
</GridColumn>
<GridColumn :sortable="true" :sorter="sorter" field="operateType" title="地址" align="left" width="80">
  <template slot="body" slot-scope="scope">
            <span :title="scope.row.operateType">{{ scope.row.operateType }}</span>
          </template>
</GridColumn>&ndash;&gt;
</DataGrid>-->
      <el-table :data="event_data" size="mini" height='320px'
        :header-cell-style="{ background: '#343434', color: '#c7c7c9', border: '1px solid #343434' }"
        style="width: 100%">
        <el-table-column prop="id" align="center" label="用户信息" width="250">
        </el-table-column>
        <el-table-column prop="name" align="center" label="姓名" width="550">
        </el-table-column>
        <el-table-column prop="creatTime" align="center" label="上线时间" width="555">
        </el-table-column>
        <el-table-column prop="address" align="center" label="地址">
        </el-table-column>
      </el-table>
    </div>
    <!--事件列表的右键菜单-->
    <Menu ref="event_context_menu" :duration="1000" @itemClick="tree_menuItemClick">
      <MenuItem text="编辑" iconCls="icon-showAlarm">
      </MenuItem>
      <MenuItem text="授权" iconCls="icon-showAlarm">
      </MenuItem>
      <MenuItem text="删除" iconCls="icon-showCommand">
      </MenuItem>
      <!--<MenuItem
        text="全部下线"
        iconCls="icon-showLog"
      ></MenuItem>-->
      <!--<Menu-sep />
      <MenuItem
        text="所有事件"
        iconCls="icon-allEvents"
      ></MenuItem>
      <MenuItem
        text="事件过滤"
        iconCls="icon-eventFilter"
      ></MenuItem>
      <Menu-sep />
      <MenuItem
        text="查找..."
        iconCls="icon-search"
      ></MenuItem>
      <Menu-sep />-->
      <!-- <MenuItem
        text="刷新"
        iconCls="icon-reflash"
      >
      <div
        align="right"
        style="font-size: 12px"
      >F5</div>
      </MenuItem>-->
    </Menu>
    <div class="pagination-box">
      <!-- <gs-pagination
        ref="pagination"
        :current="1"
        :before-jump="page => beforeJump(page)"
        :total="total"
        :page-size="params.pageSize"
        class="gs-pagination"
        @page-change="pageChange"
      />-->
      <el-pagination :page-size="params.pageSize" :current-page="params.pageNum" :pager-count="count"
        @current-change="pageChange" layout="prev, pager, next" :page-count="pages">
      </el-pagination>
    </div>

  </div>
</template>
<script>
import service from '../../service/alarmService.js'
import timeExchange from '../../utils/timestampToFormat.js'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      count: 11,
      pages: 0,
      params: {
        pageSize: 50,
        pageNum: 1,
        sortField: 'timestamp',
        sortOrder: 'desc'
      },
      loading: true,
      total: 0,
      pages: 0,
      event_data: [],
      showList: [],
      timeExchange: timeExchange,
      timer: null,
      bottom_height: `${(document.documentElement.clientHeight - 100) * 0.5 - 85}`
    }
  },
  computed: {
    ...mapState({
      loginStatus: 'loginStatus'
    })
  },
  watch: {
    loginStatus() {
      if (!this.loginStatus) {
        clearInterval(this.timer)
      }
    },
    '$store.state.userArray'(newval, olval) {
      this.webscoketUserList(newval)
    },
  },
  mounted() {
    clearInterval(this.timer)
    service.getUsersList().then(res => {
      this.total = 0
      this.event_data = res
      this.$store.state.usersNum = res.length
      this.loading = false
    }).catch(err => {
      console.log(err)
      //this.$Message.error(err.message)
      clearInterval(this.timer)
    })
    /* this.timer = setInterval(() => {
       service.getUsersList().then(res => {
         this.total = 0
         this.event_data = res
         this.$store.state.usersNum = res.length
         this.loading = false
       }).catch(err => {
         this.$Message.error(err.message)
         clearInterval(this.timer)
       })
     }, 1000)*/
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    // webscoket推送在线人数
    webscoketUserList(val) {
      this.event_data = val
    },
    sorter(field1, field2) {
      return null
    },
    tree_menuItemClick() {

    },
    beforeJump(page, pagination = 'pagination') {
      if (isNaN(page) || page < 1 || page > this.$refs[pagination].totalPage) {
        this.$Message.error('请输入正确页数')
      }
    },
    pageChange(pageNum) {
      this.params.pageNum = pageNum
      this.loading = true
      service.getEventList(this.params).then(res => {
        this.total = res.total
        this.event_data = res.data
        this.loading = false
      })
    },
    acknowledgeAlarm(row, event) {
      // row.state = 'Acknowledged'
      // service.acknowledgeAlarm(row).then(res => {
      //   alert(JSON.stringify(res))
      // })
    },
    event_right_click(event) {
      this.$refs.event_context_menu.showContextMenu(event.originalEvent.x, event.originalEvent.y)
    },
    sortChange(sorts) {
      this.params.sortField = sorts[0].field
      this.params.sortOrder = sorts[0].order
      this.pageChange(this.params.pageNum)
    }
    // showTime (row, column) {
    //   alert(column)
    // }
  }
}
</script>
<style lang='scss'>
.event-table {
  background-color: #525659;
  margin-bottom: 12px;
}

.pagination-box {
  min-width: 620px;
  float: right;

  .gs-pagination {
    margin-bottom: 16px;
  }
}

// #rMenu {
//   position:absolute;
//   visibility:hidden;
//   top:0;
//   background-color: #fff;
//   text-align: left;
//   padding: 2px;
//   border: 1px solid #DFDFDF;
//   font-size: 14px;
// }
// .right-menu-li{

// 	margin: 1px 0;
// 	padding: 5px 15px 5px 10px;
// 	cursor: pointer;
// 	list-style: none outside none;
// 	background-color: #fff;
//   border-bottom: 1px solid #DFDFDF;
// }</style>



// WEBPACK FOOTER //
// src/components/alarm/usersList.vue